import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RoleBasedHome = () => {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (user.role === 'tenant') {
        return <Navigate to="/tenant" replace />
    }

    if (user.role === 'landlord') {
        return <Navigate to="/landlord" replace />
    }

    return <div>Unauthorised</div>;
};

export default RoleBasedHome;